<template>
    <el-drawer class="notifycation-container" id="notifycationContainer" :visible="drawVisible" direction="ttb"
        size="100%" :show-close="false" :modal="false">
        <div slot="title" class="notifycation-header">
            <span>消息提醒</span>
            <span v-show="total > 0">{{total}}条未读</span>
        </div>
        <div class="notifycation-content" v-if="data.length>0" v-infinite-scroll="load" infinite-scroll-disabled="disabled"
            infinite-scroll-immediate="false">
            <AccidentItem v-for="(item, index) in data" :key="index" :data="item"></AccidentItem>
            <div class="loading" v-if="loading">加载中...</div>
            <div class="nomore" v-if="noMore && data.length>20">没有更多了</div>
        </div>
        <div class="notifycation-content" :style="{justifyContent: 'center', alignItems: 'center'}" v-else>
            <img :src="require('../../assets/img/not_found_data.png')" alt="">
        </div>
        <div class="notifycation-footer" @click="clear">
            清空消息记录
        </div>
    </el-drawer>
</template>

<script>
    import AccidentItem from './AccidentItem';
    export default {
        props: {
            drawVisible: Boolean,
        },
        components: {
            AccidentItem
        },
        methods: {
            load() {
                // this.$emit('loadMore');
                // console.log('加载下一页')
                this.$store.commit('addPage');
                this.$store.dispatch('loadMoreData');
            },
            clear() {
                if (this.total === 0) {
                    return;
                }
                this.$confirm('<p>确认清空当前消息记录吗?</p><p>清空当前消息提醒列表中的所有消息。</p>', {
                        type: 'warning',
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        showClose: false,
                        dangerouslyUseHTMLString: true,
                        customClass: 'notifycation-comfirm'
                    })
                    .then(() => {
                        this.$store.dispatch('clearAllNotifycation');
                        this.$message({
                            type: 'success',
                            message: '清除成功'
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: '取消清除'
                        });
                    })
            }
        },
        computed: {
            data() {
                return this.$store.getters.notifycation;
            },
            status() {
                return this.$store.getters.status;
            },
            disabled() {
                return this.loading || this.noMore
            },
            loading() {
                return this.status === 'loading';
            },
            noMore() {
                return this.status === 'noMore';
            },
            total() {
                return this.$store.getters.total;
            }
        },
    }
</script>

<style lang="less" scoped>
    .notifycationbg {
        .w(1920);
        .h(1080);
        position: fixed;
        top: 0;
        right: 0;
        z-index: 2000;
    }

    .notifycation-container {
        .h(1016);
        .w(552);
        position: absolute;
        right: 0;
        left: unset;
        top: 64rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        box-shadow: 0px 4px 40px 0px rgba(0, 43, 102, 0.28);

        .notifycation-header {
            display: flex;
            align-items: center;

            :nth-child(1) {
                font-size: 24rem;
                font-weight: bold;
                color: #333333;
            }

            :nth-child(2) {
                background: #FD4238;
                border-radius: 10px;
                margin-left: 15rem;
                padding: 3rem 5rem;

                font-size: 12rem;
                font-weight: 400;
                color: #FFFFFF;
            }
        }

        .notifycation-content {
            .h(887);
            width: 100%;
            overflow: hidden;
            overflow-y: auto;
            white-space: nowrap;

            display: flex;
            justify-content: flex-start;
            flex-direction: column;
            //火狐隐藏滚动条
            scrollbar-width: none;

            .loading,
            .nomore {
                display: flex;
                justify-content: center;
                align-items: center;
                height: 5vh;
                flex-shrink: 0;
            }
        }

        // 谷歌隐藏滚动条
        ::-webkit-scrollbar {
            display: none;
            z-index: -1;
        }

        .notifycation-footer {
            .h(64);
            min-height: 64rem;
            display: flex;
            justify-content: center;
            align-items: center;
            border-top: 1px solid rgba(0, 0, 0, 0.06);
            cursor: pointer;

            font-size: 16rem;
            font-weight: 400;
            color: #999999;
        }
    }
</style>